"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeProvider = require("../../../theme/ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var _Pill = _interopRequireDefault(require("../../Pill"));

var _colours = _interopRequireDefault(require("../../../theme/colours"));

var _color = _interopRequireDefault(require("color"));

/* eslint-disable complexity */
var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);
var Item = React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      selected = _ref.selected,
      disabled = _ref.disabled,
      value = _ref.value,
      pill = _ref.pill,
      children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["className", "selected", "disabled", "value", "pill", "children"]);
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("li", (0, _extends2["default"])({}, props, {
    "data-value": value,
    ref: selected ? ref : null,
    className: (0, _classnames["default"])(classes.Item, selected && 'selected', disabled && classes.Disabled, className)
  }), children, (pill === null || pill === void 0 ? void 0 : pill.value) && /*#__PURE__*/React.createElement(_Pill["default"], {
    style: {
      backgroundColor: _colours["default"][pill.colour],
      color: (0, _color["default"])(_colours["default"][pill.colour]).isDark() ? _colours["default"].white : _colours["default"].raisin
    }
  }, pill.value));
});
exports["default"] = Item;
Item.displayName = 'Item';
//# sourceMappingURL=Item.js.map